module.exports = {
      id: "video-play-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#video-play",
      toString: function () {
        return this.url;
      }
    }